export const API = {
  POSTSEGDATA: "bookAttributes/fetchBookAttributes",
  FETCHSEASON:"bookAttributes/fetchSeasons",
  FETCHDIVISION:"bookAttributes/fetchDivision",
  FETCHIMPRINTS:"bookAttributes/fetchImprints",
  FETCHPAPERCUTOFFDATES:"bookAttributes/fetchPaperCutOffDates",
  FETCHLdcDATES:"bookAttributes/fetchLdcDates",
  FETCHOTISRECORD:"OTIS/fetchOTISRecord",
  UPDATEOTISRECORD:"OTIS/updateOTISRecord",
  UPLOAD_OTIS_DATA: "OTIS/uploadOTISData",
  GETGROSSSALES:"OTIS/getGrossSales",
  ADDUSER: "/user/addUser",
  FETCHUSERS: "/user/fetchUsers",
  fetchUserInfo: "/user/fetchUserInfo",
  LOGINUSER: "/user/loginUser",
  LOGOUTUSER: "/user/logoutUser",
  FETCHISBNSLIST: "bookAttributes/fetchIsbns",
  FetchAllIsbnList:'bookAttributes/fetchIsbns_all',
  FETCHACCOUNTS:"accounts/fetchAccounts",
  fetchSelectedSegSummary:"OTIS/fetchSelectedSegSummary",
  FETCHEANSLIST:"ean/fetchEansList",
  FETCHEANS:"bookAttributes/fetchEans",
  GETALLCOMPINIT:"OTIS/getAllGrossSales",
  FETCHDIGPOST:"OTIS/getDigPos",
  Dowanload_fetchSEGRecords:"bookAttributes/Dowanload_fetchSEGRecords",
  Download_fetchOTISRecords:"bookAttributes/ExportRecords",
  FetchBaseUrl:"/user/fetchBaseUrl",
};
